// extracted by mini-css-extract-plugin
module.exports = {"modifyEmail":"style_modifyEmail__tRt5D","tip":"style_tip__DdZzy","saveBtn":"style_saveBtn__ndvd_","errorMsg":"style_errorMsg__WIF0l"};